
export class GenericLookup {
    Id :number;
    NameEN :string;
    NameAR :string;
};